import type { MeResponse, NavigationGroupDto } from '@an-crm/shared';
import { queryOptions } from '@tanstack/react-query';
import { api } from '@/lib/api/client';

export const meQuery = queryOptions({
  queryKey: ['session', 'me'],
  queryFn: ({ signal }) => api<MeResponse>('/me', { signal }),
  staleTime: 5 * 60_000,
});

export const navigationQuery = queryOptions({
  queryKey: ['session', 'navigation'],
  queryFn: ({ signal }) => api<NavigationGroupDto[]>('/me/navigation', { signal }),
  staleTime: 5 * 60_000,
});
